import { Container } from 'react-bootstrap';

const FunnelFooter = () => {
  return (
    <footer className="funnel-footer">
      <Container>
        {/* Legal Links */}
        <div className="d-flex justify-content-center align-items-center gap-3 mb-3 flex-wrap">
          <a href="/terms" className="footer-link">
            Terms of Use
          </a>
          <span className="footer-dot">•</span>
          <a href="/privacy" className="footer-link">
            Privacy Policy
          </a>
          <span className="footer-dot">•</span>
          <a href="/cookies" className="footer-link">
            Manage Cookies
          </a>
        </div>

        {/* Powered By Badge */}
        <div className="d-flex justify-content-center">
          <div className="powered-by-container">
            <a href="https://fatagent.com" target="_blank" rel="noopener noreferrer" className="powered-by-badge">
              <img 
                src="/images/Fat Agent Logo Symbol.png" 
                alt="Fat Agent" 
                className="funnel-logo-mini"
                style={{ width: '28px', height: '28px', objectFit: 'contain' }}
              />
              <span className="powered-text">Powered by Fat Agent</span>
            </a>
            
            {/* Floating Hearts */}
            <span className="floating-heart" style={{ left: '10%', animationDelay: '0s' }}>❤️</span>
            <span className="floating-heart" style={{ left: '30%', animationDelay: '1.5s' }}>❤️</span>
            <span className="floating-heart" style={{ left: '50%', animationDelay: '3s' }}>❤️</span>
            <span className="floating-heart" style={{ left: '70%', animationDelay: '4.5s' }}>❤️</span>
            <span className="floating-heart" style={{ left: '90%', animationDelay: '6s' }}>❤️</span>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default FunnelFooter;

